import React from "react";
import moment from "moment";
import { PaperClipIcon, DocIcon, IconDelete, IconEdit } from "../../Icon";
import { testJSON } from "../../../utils/commonFunctions";
import { deleteIcon, tableEditIcon } from "../../../assets/images";
interface Props {
  data: any;
  tableHeader: any;
  editEntry: (index: number) => void;
  deleteEntry?: Function;
  loginData?: any;
}
class TableData extends React.Component<Props> {
  render() {
    const { data, tableHeader, editEntry, deleteEntry } = this.props;

    // const { user_role_id } = loginData;

    return data && Array.isArray(data)
      ? data.map((response: any, index: number) => {
          return (
            <tr>
              <td>{index + 1}</td>
              {response &&
                response.map((dataItem: any, ind: number) => {
                  return (
                    <>
                      {tableHeader.map((item: any, i: number) => {
                        if (dataItem["column_name"] === item.value) {
                          return <td>{dataItem.column_value}</td>;
                        }
                        // if ( dataItem['column_name'] !== "nature_of_income" && dataItem['column_name'] === item.value) {
                        //     return <td>{dataItem.column_value}</td>
                        // }
                        // if(dataItem['column_name'] === 'nature_of_income'
                        //     && item.value==='nature_of_income' ){

                        //     return<td>{dataItem?.column_value?.ledger_name}</td>

                        // }
                      })}
                    </>
                  );
                })}

              <td>
                <ul className="list-group list-group-horizontal action-list">
                  <li className="pointer" onClick={() => editEntry(index)}>
                    {/* <IconEdit /> */}
                    <img src={tableEditIcon} alt="edit-icon" />
                  </li>

                  {deleteEntry ? (
                    <li className="pointer" onClick={() => deleteEntry(index)}>
                      <img src={deleteIcon} alt="delete-icon" />
                      {/* <IconDelete /> */}
                    </li>
                  ) : null}
                </ul>
              </td>
            </tr>
          );
        })
      : data &&
          Object.keys(data).map((key: any, index: number) => {
            return (
              <tr>
                <td>{index + 1}</td>
                {key &&
                  data &&
                  data[key] &&
                  data[key].map((dataItem: any, ind: number) => {
                    return (
                      <>
                        {tableHeader.map((item: any, i: number) => {
                          if (dataItem["column_name"] === item.value) {
                            return <td>{dataItem.column_value}</td>;
                          }
                          // if ( dataItem['column_name'] !== "nature_of_income" && dataItem['column_name'] === item.value) {
                          //     return <td>{dataItem.column_value}</td>
                          // }
                          // if(dataItem['column_name'] === 'nature_of_income'
                          //     && item.value==='nature_of_income' ){

                          //     return<td>{dataItem?.column_value?.ledger_name}</td>

                          // }
                        })}
                      </>
                    );
                  })}

                <td>
                  <ul className="list-group list-group-horizontal action-list">
                    <li className="pointer" onClick={() => editEntry(key)}>
                      <img src={tableEditIcon} alt="edit-icon" />
                    </li>

                    {deleteEntry ? (
                      <li className="pointer" onClick={() => deleteEntry(key)}>
                        <img src={deleteIcon} alt="delete-icon" />
                      </li>
                    ) : null}
                  </ul>
                </td>
              </tr>
            );
          });
  }
}

export default TableData;
